import {Inject, Injectable} from '@angular/core';
import {IFileManagerConfiguration} from './IFileManagerConfiguration';
import {HttpClient} from '@angular/common/http';
import {NodeService} from "../../angular2-tree/service/node.service";

@Injectable()
export class TreeService extends NodeService {
  public constructor(protected http: HttpClient, @Inject('fileManagerConfiguration') configuration: IFileManagerConfiguration) {
    super(http);

    this.apiConfig = {
      addUrl: configuration.urls.foldersUrl,
      getUrl: configuration.urls.foldersUrl,
      updateUrl: configuration.urls.foldersUrl,
      removeUrl: configuration.urls.foldersUrl,
      moveUrl: configuration.urls.folderMoveUrl
    };
  }
}
